import styled from 'styled-components';

export const ScBadge = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  padding: 0 4px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
  border-radius: 360px;
  background: ${({ theme }) => theme.mainColor};
  color: ${({ theme }) => theme.whiteColor};
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0;
`;
